import {
  View,
  Text,
  StyleSheet,
  TextInput,
  Platform,
  TouchableOpacity,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { lightBlue } from "../../colors";
import { manifest } from "expo-updates";
import { useSelector } from "react-redux";

export default function CodeInput({ setCode, codeDone, direction }) {
  const main = useSelector((store) => store.main);
  const input1 = useRef(null);
  const input2 = useRef(null);
  const input3 = useRef(null);
  const input4 = useRef(null);
  const input5 = useRef(null);
  let [inputCode1, setInputCode1] = useState(0);
  let [inputCode2, setInputCode2] = useState(0);
  let [inputCode3, setInputCode3] = useState(0);
  let [inputCode4, setInputCode4] = useState(0);
  let [inputCode5, setInputCode5] = useState(0);

  let persianNumber = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  function correctNumber(text) {
    let chars = text.split("");
    for (let i = 0; i < chars.length; i++) {
      if (/\d/.test(chars[i])) {
        chars[i] = persianNumber[chars[i]];
      }
    }
    return chars.join("");
  }
  return (
    <View
      style={[
        styles.container,
        {
          flexDirection:
            Platform.OS === "web" || (Platform.OS === "android" && main.rtl)
              ? "row-reverse"
              : "row",
        },
      ]}
    >
      <TouchableOpacity onPress={() => input1.current.focus()}>
        <TextInput
          keyboardType={Platform.OS === "android" ? "numeric" : "number-pad"}
          ref={input1}
          maxLength={1}
          style={styles.codeInput}
          onKeyPress={(e) =>
            Platform.OS !== "web" &&
            (e.nativeEvent.key === "Backspace"
              ? input1.current.focus()
              : input2.current.focus())
          }
          onKeyUp={(e) =>
            Platform.OS === "web" &&
            (e.nativeEvent.key === "Backspace"
              ? input1.current.focus()
              : input2.current.focus())
          }
          onChangeText={(text) => {
            setInputCode1(text);
          }}
        />
      </TouchableOpacity>
      <TouchableOpacity onPress={() => input2.current.focus()}>
        <TextInput
          keyboardType={Platform.OS === "android" ? "numeric" : "number-pad"}
          maxLength={1}
          ref={input2}
          style={styles.codeInput}
          onKeyPress={(e) =>
            Platform.OS !== "web" &&
            (e.nativeEvent.key === "Backspace"
              ? input1.current.focus()
              : input3.current.focus())
          }
          onKeyUp={(e) =>
            Platform.OS === "web" &&
            (e.nativeEvent.key === "Backspace"
              ? input1.current.focus()
              : input3.current.focus())
          }
          onChangeText={(text) => {
            setInputCode2(text);
          }}
        />
      </TouchableOpacity>
      <TouchableOpacity onPress={() => input3.current.focus()}>
        <TextInput
          keyboardType={Platform.OS === "android" ? "numeric" : "number-pad"}
          maxLength={1}
          ref={input3}
          style={styles.codeInput}
          onKeyPress={(e) =>
            Platform.OS !== "web" &&
            (e.nativeEvent.key === "Backspace"
              ? input2.current.focus()
              : input4.current.focus())
          }
          onKeyUp={(e) =>
            Platform.OS === "web" &&
            (e.nativeEvent.key === "Backspace"
              ? input2.current.focus()
              : input4.current.focus())
          }
          onChangeText={(text) => {
            setInputCode3(text);
          }}
        />
      </TouchableOpacity>
      <TouchableOpacity onPress={() => input4.current.focus()}>
        <TextInput
          keyboardType={Platform.OS === "android" ? "numeric" : "number-pad"}
          maxLength={1}
          ref={input4}
          style={styles.codeInput}
          onKeyPress={(e) =>
            Platform.OS !== "web" &&
            (e.nativeEvent.key === "Backspace"
              ? input3.current.focus()
              : input5.current.focus())
          }
          onKeyUp={(e) =>
            Platform.OS === "web" &&
            (e.nativeEvent.key === "Backspace"
              ? input3.current.focus()
              : input5.current.focus())
          }
          onChangeText={(text) => {
            setInputCode4(text);
          }}
        />
      </TouchableOpacity>
      <TouchableOpacity onPress={() => input5.current.focus()}>
        <TextInput
          onPress={() => {}}
          keyboardType={Platform.OS === "android" ? "numeric" : "number-pad"}
          maxLength={1}
          ref={input5}
          style={styles.codeInput}
          onKeyPress={(e) =>
            Platform.OS !== "web" &&
            (e.nativeEvent.key === "Backspace" ? input4.current.focus() : null)
          }
          onKeyUp={(e) =>
            Platform.OS === "web" &&
            (e.nativeEvent.key === "Backspace" ? input4.current.focus() : null)
          }
          onChangeText={(text) => {
            setInputCode5(text);
            if (text !== "") {
              const code = `${inputCode1}${inputCode2}${inputCode3}${inputCode4}${text}`;
              setCode(code);
              codeDone !== undefined ? codeDone() : null;
            }
          }}
        />
      </TouchableOpacity>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    direction: "rtl",
    marginTop: 10,
    width: "100%",
    display: "flex",

    justifyContent: "space-between",
  },
  codeInput: {
    borderRadius: Platform.OS === "android" ? 8 : 13,

    height: 45,
    backgroundColor: lightBlue,
    width: 45,
    borderRadius: 10,
    textAlign: "center",
    fontSize: 20,
  },
});
